import { v4 as uuid4 } from 'uuid'

import { MATERIAL_ICONS } from '@makyoapp/makyo-ui'

import {
  BuilderOverlay,
  DEFAULT_OVERLAY_PLACEMENT,
  DEFAULT_OVERLAY_SHAPE,
  DEFAULT_OVERLAY_SIZE,
} from '@/shared/overlay'
import { createSlug } from '@/shared/utils'

export function genNewOverlay(overlays: BuilderOverlay[], title?: string): BuilderOverlay {
  let defaultTitle = title || 'New Overlay'
  return {
    id: uuid4(),
    title: defaultTitle,
    slug: createSlug(defaultTitle),
    actions: [],
    icon: MATERIAL_ICONS[Math.floor(Math.random() * MATERIAL_ICONS.length)]?.value ?? 'home',
    bgColor: 'primary-90',
    elements: [],
    elementSettings: {},
    type: '',
    visibility: {
      isAny: true,
      conditions: [],
    },
    visible: false,
    enabled: true,
    closeBehavior: 'direct',
    opacity: 85,
    // breakpoints related settings
    placement: DEFAULT_OVERLAY_PLACEMENT,
    size: DEFAULT_OVERLAY_SIZE,
    shape: DEFAULT_OVERLAY_SHAPE,
    alignment: 'center',
  }
}
